module.exports = __webpack_public_path__ + "img/3234bb1.svg";